import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from 'yup';
import { emlakBasvuruValidation } from "../../../validations/EmlakBasvuru";
import ResponsiveTabs from "../../../components/OB/Tabbar";
import { Box } from "@mui/material";
import { useState } from "react";
import StajBasvuru from "./staj-basvuru";
import BursBasvuru from "./burs-basvuru";
import StajBursBasvuruTakipPage from "./staj-burs-takip";
import SessionStorageService from "../../../services/StorageService";
import TcTelefonSmsControlPopup from "../../../components/OB/popups/tc-telefon-fogrulama-popup";

const StajBursBase = () => {
  const [value, setValue] = useState(0);
  const user = SessionStorageService.getUserInfo();
  const [smsControlled, setSmsControlled] = useState(user != null);
  const [tcKimlikNo, setTcKimlikNo] = useState(user ? user.tcKimlikNo : "");
  const [cepTelefonu, setCepTelefonu] = useState("");
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <>
      {!smsControlled ? (
        <TcTelefonSmsControlPopup
          smsControlledSet={setSmsControlled}
          cepTelefonuSet={setCepTelefonu}
          tcKimlikNoSet={setTcKimlikNo}
        />
      ) : (
        <div>
          <ResponsiveTabs
            items={[
              { title: "Staj Başvuru", onClick: () => console.log("Tab 1 clicked") },
              { title: "Burs Başvuru", onClick: () => console.log("Tab 2 clicked") },
              { title: "Başvuru Takip", onClick: () => console.log("Tab 3 clicked") },
            ]}
            value={value}
            onChange={handleChange}
            spreadWidth={false}
          />
          <Box className="pt-2">
            {value === 0 && <StajBasvuru cepTelefonu={cepTelefonu} tcKimlikNo={tcKimlikNo} />}
            {value === 1 && <BursBasvuru cepTelefonu={cepTelefonu} tcKimlikNo={tcKimlikNo} />}
            {value === 2 && <StajBursBasvuruTakipPage tcKimlikNo={tcKimlikNo} />}
          </Box>
        </div>
      )}
    </>
  );
};

export default StajBursBase;
